export default "__VITE_ASSET__CGU6NqKt__"